import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { UserModel } from 'app/models/user.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService<UserModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'user');
    }

    uploadPhoto(formData: FormData): Observable<any> {
        return this.api.postSub(`${this.endpoint}/uploadPhoto`, formData);
    }

    uploadFile(formData: FormData): Observable<any> {
        return this.api.postSub(`${this.endpoint}/uploadFile`, formData);
    }

    /** Import users from CSV (ADMIN only). permission_group_id: grupo selecionado no dropdown */
    importFromCsv(
        file: File,
        company_id: number,
        permission_group_id: number,
    ): Observable<{ created: number; associated?: number; skipped_duplicate: number; errors: { row: number; email_or_name: string; message: string }[] }> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('company_id', String(company_id));
        formData.append('permission_group_id', String(permission_group_id));
        return this.api.postSub(`${this.endpoint}/import`, formData);
    }

    /** Reenviar link de redefinição de senha ao usuário (ADMIN). user_id do usuário que receberá o email. */
    sendResetPasswordLink(user_id: number): Observable<{ sent: boolean }> {
        return this.api.postSub(`${this.endpoint}/${user_id}/send-reset-password`, {});
    }
}
